// removed by extract-text-webpack-plugin
module.exports = {"root":"PartsPicker__root___lZoVG","part":"PartsPicker__part___3FUwu","heading":"PartsPicker__heading___CNGce","subHeading":"PartsPicker__subHeading___1giqG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PartsPicker.scss
// module id = 258
// module chunks = 1